<template>
  <div class="legend-container">
    <div class="ui segment">
      <div class="row expanded collapse">
        <div class="columns small-12 medium-6 large-3">
          <div class="row expanded">
            <div class="small-6 columns legend-col"><span class="legend free"></span></div>
            <div class="small-6 columns legend-text">{{ trans.free }}</div>
          </div>
        </div>
        <div v-if="isAvailable('club')"
             class="columns small-12  medium-6 large-3">
          <div class="row expanded">
            <div class="small-6 columns legend-col">
              <span class="legend club">
                <img v-if="IS_CORDOVA_APP"
                     :alt="trans.clubReservationImgAlt"
                     :src="trans.clubReservationImgUrl">
                <img v-else
                     :alt="trans.clubReservationImgAlt"
                     :src="`/${trans.clubReservationImgUrl}`">
              </span>
            </div>
            <div class="small-6 columns legend-text">{{ trans.club }}</div>
          </div>
        </div>
        <div v-if="isAvailable('own')"
             class="columns small-12  medium-6 large-3">
          <div class="row expanded">
            <div class="small-6 columns legend-col">
              <span class="legend own-guest">
                <img v-if="IS_CORDOVA_APP"
                     :alt="trans.ownReservationImgAlt"
                     :src="trans.ownReservationImgUrl">
                <img v-else
                     :alt="trans.ownReservationImgAlt"
                     :src="`/${trans.ownReservationImgUrl}`">
              </span>
            </div>
            <div class="small-6 columns legend-text">{{ trans.ownReservation }}</div>
          </div>
        </div>
        <div v-if="isAvailable('own-trainer')"
             class="columns small-12  medium-6 large-3">
          <div class="row expanded">
            <div class="small-6 columns legend-col">
              <span class="legend own-trainer">
                <img v-if="IS_CORDOVA_APP"
                     :alt="trans.ownTrainerReservationImgAlt"
                     :src="trans.ownTrainerReservationImgUrl">
                <img v-else
                     :alt="trans.ownTrainerReservationImgAlt"
                     :src="`/${trans.ownTrainerReservationImgUrl}`">
              </span>
            </div>
            <div class="small-6 columns legend-text">{{ trans.ownTrainerReservation }}</div>
          </div>
        </div>
        <div class="columns small-12  medium-6 large-3">
          <div class="row expanded">
            <div class="small-6 columns legend-col">
              <span class="legend reserved">
                <img v-if="IS_CORDOVA_APP"
                     :alt="trans.reservedImgAlt"
                     :src="trans.reservedImgUrl">
                <img v-else
                     :alt="trans.reservedImgAlt"
                     :src="`/${trans.reservedImgUrl}`">
              </span>
            </div>
            <div class="small-6 columns legend-text">{{ trans.reserved }}</div>
          </div>
        </div>
        <div v-if="isAvailable('closed')"
             class="columns small-12  medium-6 large-3">
          <div class="row expanded">
            <div class="small-6 columns legend-col"><span class="legend closed"></span></div>
            <div class="small-6 columns legend-text">{{ trans.closed }}</div>
          </div>
        </div>

        <div v-if="isAvailable('own-w-partner')"
             class="columns small-12  medium-6 large-3">
          <div class="row expanded">
            <div class="small-6 columns legend-col">
              <span class="legend own-guest partner-outer">
                <img v-if="IS_CORDOVA_APP"
                     :alt="trans.ownReservationImgAlt"
                     :src="trans.ownReservationImgUrl">
                <img v-else
                     :alt="trans.ownReservationImgAlt"
                     :src="`/${trans.ownReservationImgUrl}`">
                <i class='user icon'></i>
              </span>
            </div>
            <div class="small-6 columns legend-text">{{ trans.own_w_partner }}</div>
          </div>
        </div>

        <div v-if="isAvailable('reserved-w-partner')"
             class="columns small-12  medium-6 large-3">
          <div class="row expanded">
            <div class="small-6 columns legend-col">
              <span class="legend reserved  partner-outer">
                <img v-if="IS_CORDOVA_APP"
                     :alt="trans.ownReservationImgAlt"
                     :src="trans.ownReservationImgUrl">
                <img v-else
                     :alt="trans.ownReservationImgAlt"
                     :src="`/${trans.ownReservationImgUrl}`">
                <i class='user icon'></i>
              </span>
            </div>
            <div class="small-6 columns legend-text">{{ trans.reserved_w_partner }}</div>
          </div>
        </div>

        <div v-if="isAvailable('partner-available')"
             class="columns small-12  medium-6 large-3">
          <div class="row expanded">
            <div class="small-6 columns legend-col"><span class="legend partner-available"></span></div>
            <div class="small-6 columns legend-text">{{ trans.partner_available }}</div>
          </div>
        </div>

        <div v-if="isAvailable('own-available')"
             class="columns small-12  medium-6 large-3">
          <div class="row expanded">
            <div class="small-6 columns legend-col"><span class="legend own-available"></span></div>
            <div class="small-6 columns legend-text">{{ trans.own_available }}</div>
          </div>
        </div>

        <div v-if="isAvailable('partner-incomings')"
             class="columns small-12  medium-6 large-3">
          <div class="row expanded">
            <div class="small-6 columns legend-col"><span class="legend partner-incomings"></span></div>
            <div class="small-6 columns legend-text">{{ trans.partner_incomings }}</div>
          </div>
        </div>

        <div v-if="isAvailable('partner-outgoings')"
             class="columns small-12  medium-6 large-3">
          <div class="row expanded">
            <div class="small-6 columns legend-col"><span class="legend partner-outgoings"></span></div>
            <div class="small-6 columns legend-text">{{ trans.partner_outgoings }}</div>
          </div>
        </div>

        <div v-if="isAvailable('partner-accepted-wo-reserve')"
             class="columns small-12  medium-6 large-3">
          <div class="row expanded">
            <div class="small-6 columns legend-col"><span class="legend partner-accepted-wo-reserve"></span></div>
            <div class="small-6 columns legend-text">{{ trans.partner_accepted_wo_reserve }}</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import {mapState} from 'vuex'

export default {
  data () {
    return {
      IS_CORDOVA_APP: config.IS_CORDOVA_APP,
    }
  },
  methods: {
    availableTypes () {
      let availableStatuses = []
      let tables = this.tables
      for (let table of tables) {
        for (let day of table.days) {
          for (let subject of day.subjects) {
            for (let item of subject.fill) {
              if (!availableStatuses.includes(item.status)) {
                availableStatuses.push(item.status)
              }
              if (item.status == 'own' && item.partner && !availableStatuses.includes('own-w-partner'))
                availableStatuses.push('own-w-partner')
              if (item.status == 'reserved' && item.partner && !availableStatuses.includes('reserved-w-partner'))
                availableStatuses.push('reserved-w-partner')
              if (item.ownAvailable && !availableStatuses.includes('own-available')) availableStatuses.push('own-available');
              if (item.partnerAvailable && !availableStatuses.includes('partner-available')) availableStatuses.push('partner-available');
              if (item.partnerIncomings && !item.acceptedWithoutReserve && !availableStatuses.includes('partner-incomings')) availableStatuses.push('partner-incomings');
              if (item.partnerOutgoings && !item.acceptedWithoutReserve && !availableStatuses.includes('partner-outgoings')) availableStatuses.push('partner-outgoings');
              if (item.acceptedWithoutReserve && !availableStatuses.includes('partner-accepted-wo-reserve')) availableStatuses.push('partner-accepted-wo-reserve');
            }
          }
        }
      }
      return availableStatuses
    },
    isAvailable (status) {
      return !!this.availableTypes().includes(status)
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.scheduleLegend,
    }),
    tables () {
      return this.$store.state.tables
    },
  },
}
</script>

<style scoped>
.legend-container {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 1rem;
}

.legend {
  height: 2rem;
  width: 2rem;
  background: white;
  display: inline-block;
  text-align: center;
  position: relative;
}

.free {
  border: 1px solid rgba(34, 36, 38, .15);
}

.own-guest {
  background: #a1cba5;
}

.own-trainer {
  background: #a1b0cb;
}

.reserved {
  background: #e5bdbd;
}

.club {
  background: #e3c6a4;
}

.closed {
  background: repeating-linear-gradient(45deg, #fff, #fff 10px, #d9d9d9 0, #d9d9d9 20px);
  color: rgba(255, 0, 0, 0);
}

.legend-col {
  text-align: right;
}

.legend-text {
  padding-top: 0.3rem;
}

.legend > img {
  padding: 5px;
  max-height: 100%;
}

.partner-outer > i {
  position: absolute;
  color: #cc5500;
  right: -2px;
  bottom: 3px;
  font-size: 1.25rem;
  text-align: right;
}

.own-available {
  background-color: #c8dfef;
}

.partner-available {
  background-color: #92c47a7a;
}

.partner-incomings {
  background-color: #a9fb76c2;
}

.partner-outgoings {
  background-color: #ffb733c2;
}

.partner-accepted-wo-reserve {
  background: #ff5e00e3 !important;
}
</style>
